import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import { getLanguageFromLocale } from '@ratehub/base-ui';
import { Products, FeaturedProductList } from '@ratehub/web-components';
import {
    CreditCardSynopsisShape,
    getCardProductTypeName,
    getCreditCardURL,
    CC_URL_SLUGS,
    PRODUCT_TYPES,
} from '@ratehub/cc-common';


function CardComparisonList({ productType, cards }) {
    const intl = useIntl();
    const languageCode = getLanguageFromLocale(intl.locale);

    return (
        <FeaturedProductList
            heading={{
                title: intl.formatMessage(
                    MESSAGES.compareAllOthersTitle,
                    { productType: getCardProductTypeName({ productType }, languageCode) },
                ),
            }}

            href={getCreditCardURL(languageCode, CC_URL_SLUGS.CARDFINDER)}

            hrefText={intl.formatMessage(MESSAGES.compareAllOthers)}

            productType={Products.CREDIT_CARDS}
            products={cards}

            verifyProvince={false}      // we do NOT need to verify this: country-wide
        />
    );
}

CardComparisonList.propTypes = {
    productType: PropTypes.oneOf(Object.values(PRODUCT_TYPES)).isRequired,
    cards: PropTypes.arrayOf(PropTypes.shape({
        propertyType: PropTypes.string,
        title: PropTypes.string,
        isSponsored: PropTypes.bool,

        applyHref: PropTypes.string,
        applyText: PropTypes.string,
        imageSrc: PropTypes.string,
        imageAlt: PropTypes.string,

        description: PropTypes.string,
        providerSlug: PropTypes.string,
        detailsHref: PropTypes.string,
        isMonetized: PropTypes.bool,

        creditCardSynopsis: PropTypes.shape(CreditCardSynopsisShape).isRequired,
    })).isRequired,
};


const MESSAGES = defineMessages({
    compareAllOthersTitle: {
        id: 'cc.details.compare-all-others-title',
        defaultMessage: 'Compare against our best {productType} cards',
    },

    compareAllOthers: {
        id: 'cc.details.compare-all-others',
        defaultMessage: 'Compare all',
    },
});

export default CardComparisonList;
